<template>
	<el-header>
		<div class="header">
			<div class="content">
				<div class="logo"><img src="../assets/header/logo.png" :alt="SystemOption.seoKeyWord"></div>
				<div class="logo-mobile">
					<img src="../assets/mobile/logo.png" :alt="SystemOption.seoKeyWord">
					<img class="directory" src="../assets/mobile/mulu.png" :alt="SystemOption.seoKeyWord" @click="directoryShow==false?directoryShow=true:directoryShow=false">
				</div>
				<div class="item email">
					<img src="../assets/header/youjian.png" :alt="SystemOption.seoKeyWord">
					<div class="T-value">
						<span>邮件地址</span>
						<span>{{ContactUs.email}}</span>
					</div>
				</div>
				<div class="item phone">
					<img src="../assets/header/dianhua.png" :alt="SystemOption.seoKeyWord">
					<div class="T-value">
						<span>法律咨询电话</span>
						<span>{{ContactUs.lawServiceTel}}</span>
					</div>
				</div>
				<div class="item address">
					<img src="../assets/header/dizhi.png" :alt="SystemOption.seoKeyWord">
					<div class="T-value">
						<span>律所地址</span>
						<span>{{ContactUs.address}}</span>
					</div>
				</div>
			</div>
			<div v-if="directoryShow" class="mobile-directory">
				<router-link class="directory-item" v-for="(x,i) in navList" :key="i" :to="x.url">
					{{x.name}}
				</router-link>
			</div>
		</div>
		<div class="nav">
			<ul class="navList">
				<router-link v-for="(x,i) in navList" :key="i" :to="x.url">
					<li @click="NavCHange(x,i)" :class="{'act':navChange==i}">{{x.name}}</li>
				</router-link>
			</ul>
		</div>
	</el-header>
</template>

<script>
	export default {
		name: 'Header',
		props: {
			act: Number
		},
		data() {
			return {
				navList: [],
				ContactUs: [],
				SystemOption: [],
				navChange: 0,
				directoryShow: false,
			}
		},
		computed: {
			//监听菜单栏变化
			getStoreNavListChecked() {
				return this.$store.state.navChangeChecked;
			}
		},
		methods: {
			NavCHange(x, i) {
				this.navChange = i;
				this.$store.state.navChangeChecked = i;
			},
			// 移动端导航栏
			toMoilePage(url){
				this.directoryShow = false
				this.$router.push({
					path:url
				})		
			}
		},
		mounted: function() {
			this.axios.get(this.Url.apiUrl + "ContactUs").then(res => this.ContactUs = res.data)
			// 导航栏
			this.axios.get(this.Url.apiUrl + "NavigationBar/GetNavigationBar").then(res => {
				this.navList = res.data;
				this.$store.state.NavList = res.data;
			})
			//获取SEO配置
			this.axios.get(this.Url.apiUrl + "SystemOption/GetSystemOption").then(res => this.SystemOption = res.data);
			//导航栏初始化
			this.navChange = this.$store.state.navChangeChecked;
		}


	}
</script>

<style lang="scss" scoped>
	.el-header {
		width: 100%;
		height: auto !important;
		z-index: 999999999;
		position: fixed;
		

		@media screen and (max-width: 768px){
			position: relative;
			
		}
		.header {
			width: 100%;
			height: 80px;
			margin: 0 auto;
			background: #fff;
			@media screen and (max-width: 768px) {
				height: auto;
			}

			.content {
				position: relative;
				width: 1200px;
				height: 100%;
				margin: 0 auto;
				display: flex;
				justify-content: space-between;
				align-items: center;

				@media screen and (max-width: 768px) {
					background-color: #bd9d6c;
					box-shadow: 0px 1px 1px 0px rgba(129, 108, 77, 0.3);
					width: 100%;
					height: 50px;
					position: relative;
					justify-content: center;
				}

				.logo {
					display: block;

					@media screen and (max-width: 768px) {
						display: none;
					}

					img {
						width: 319px;
					}
				}

				.logo-mobile {
					display: none;

					@media screen and (max-width: 768px) {
						display: block;
					}

					img {
						width: 172px;
						height: 21.6px;
					}

					.directory {
						position: absolute;
						height: 13.33px;
						width: 23.3px;
						right: 16px;
						top: 18px;
					}
				}

				.item {
					display: flex;
					justify-content: space-around;
					// flex: 0 0 223px;
					align-items: center;

					@media screen and (max-width: 768px) {
						display: none;
					}

					img {
						flex: 0 0 35px;
						height: 30px;
						margin-right: 10px;
					}

					span {
						display: block;
						font-size: 14px;
						color: #545454;
						line-height: 20px;
						@media screen and (max-width:1300px){
						font-size: 12px;
							
						}
					}
				}

				.item.phone {
					// flex: 0 0 145px;
					margin: 0 30px 0 0;
					img {
						flex: 0 0 24px;
						height: 30px;
					}
				}

				.item.address {
					// flex: 0 0 170px;

					img {
						flex: 0 0 31px;
						height: 31px;
					}
				}
			}

			.mobile-directory {
				display: none;

				@media screen and (max-width: 768px) {
					display: block;
					position: absolute;
					width: 100%;
					height: calc(100% - 50px);
					bottom: 0;
					left: 0;
					background-color: rgba(0, 0, 0, .6);
					z-index: 99999999;
					.directory-item {
						display: block;
						width: 100%;
						border-bottom: 1px solid #838383;
						margin: 0 auto;
						line-height: 50px;
						text-decoration: none;
						color: #fff;
						z-index: 99999999;
						position: relative;
						background: rgba(0,0,0,0.6);
						padding: 0 33px;
					}
				}
			}
		}

		.nav {
			position: relative;
			height: 40px;
			width: 100%;
			background: rgba(0, 0, 0, .6);
			padding: 0;
			z-index: 999;

			@media screen and (max-width: 768px) {
				display: none;
			}

			.navList {
				position: relative;
				display: flex;
				list-style: none;
				margin: 0 auto;
				width: 1200px;
				padding: 0 !important;

				li {
					width: 150px;
					height: 100%;
					text-align: center;
					line-height: 40px;
					color: #fff;
					cursor: pointer;
					letter-spacing: 2px;

					a {
						color: #fff;
						text-decoration: none;
					}
				}

				li.act {
					background-color: #bd9d6c;
				}
			}

		}
	}
</style>
